export default __webpack_public_path__ + "tmp_src/components/StatsSection/StatsSection.css.liquid";